import { Button } from '@progress/kendo-react-buttons';
import { useState } from 'react';
import { AuthService } from '../../../../../services/axios/axios-api-v2-generated';
import { LoadingIndicatorCircular } from '../../../../components/indicators/LoadingIndicatorCircular';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { addNotification, NotificationType } from '../../../../state/slices/global-slice';

export function DtnToolbarItem() {
    const [busy, setBusy] = useState(false);
    const show = useAppSelector((x) => x.user.rights.DtnAviation);
    const dispatch = useAppDispatch();

    if (!show) {
        return null;
    }

    return (
        <Button
            className="button-small k-rounded-full"
            title="Aviation Sentry"
            data-tooltip-bottom
            disabled={busy}
            onClick={async () => {
                try {
                    setBusy(true);
                    const response = await AuthService.aviationSentryLoginAsync({ withAuthorization: true });
                    if (response.redirectUrl) {
                        window.open(response.redirectUrl, '_blank');
                    }
                } catch {
                    dispatch(
                        addNotification({
                            type: NotificationType.generalError,
                            customMessage: 'Failed to open Aviation Sentry'
                        })
                    );
                } finally {
                    setBusy(false);
                }
            }}>
            {busy ? (
                <LoadingIndicatorCircular size="20px" />
            ) : (
                <img src="img/dtn_logo.svg" height="20" alt="dtn-logo" title="Aviation Sentry" data-tooltip-bottom />
            )}
        </Button>
    );
}
